import { render } from "./ExpenseReceiptCreateDocumentSupplierCard.vue?vue&type=template&id=0f22f2fa&scoped=true"
import script from "./ExpenseReceiptCreateDocumentSupplierCard.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptCreateDocumentSupplierCard.vue?vue&type=script&lang=js"

import "./ExpenseReceiptCreateDocumentSupplierCard.vue?vue&type=style&index=0&id=0f22f2fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f22f2fa"]])

export default __exports__